import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard,
  Calendar,
  Newspaper,
  Users,
  Handshake,
  Image,
  UserCog,
  MessageSquare,
  LogOut,
  Home
} from 'lucide-react';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard', exact: true },
    { path: '/admin/jogos', icon: Calendar, label: 'Jogos' },
    { path: '/admin/noticias', icon: Newspaper, label: 'Notícias' },
    { path: '/admin/plantel', icon: Users, label: 'Plantel' },
    { path: '/admin/patrocinadores', icon: Handshake, label: 'Patrocinadores' },
    { path: '/admin/galeria', icon: Image, label: 'Galeria' },
    { path: '/admin/direcao', icon: UserCog, label: 'Direção' },
    { path: '/admin/mensagens', icon: MessageSquare, label: 'Mensagens' },
  ];

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0A0A0A] border-r border-white/10 fixed h-full" data-testid="admin-sidebar">
        <div className="p-6 border-b border-white/10">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
              <span className="font-heading font-black text-black text-sm">GDR</span>
            </div>
            <div>
              <span className="font-heading font-bold text-sm tracking-tight block">GDR ESPORÕES</span>
              <span className="text-xs text-gray-500">Administração</span>
            </div>
          </Link>
        </div>

        <nav className="py-4">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-link ${isActive(item.path, item.exact) ? 'active' : ''}`}
              data-testid={`admin-nav-${item.label.toLowerCase()}`}
            >
              <item.icon size={18} />
              <span className="text-sm">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10">
          <div className="flex items-center justify-between mb-4">
            <div>
              <p className="text-sm font-medium">{user?.name || 'Admin'}</p>
              <p className="text-xs text-gray-500">{user?.username}</p>
            </div>
          </div>
          <div className="flex gap-2">
            <Link
              to="/"
              className="flex-1 flex items-center justify-center gap-2 py-2 border border-white/10 text-gray-400 hover:text-white hover:border-white/30 transition-all text-xs"
            >
              <Home size={14} />
              Site
            </Link>
            <button
              onClick={logout}
              className="flex-1 flex items-center justify-center gap-2 py-2 border border-white/10 text-gray-400 hover:text-white hover:border-white/30 transition-all text-xs"
              data-testid="admin-logout"
            >
              <LogOut size={14} />
              Sair
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
